import Layout from '@/views/layout/Index.vue'

export const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/install',
    name: 'install',
    component: () => import('@/views/install/index.vue'),
    meta: { title: '初始化安装' }
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        redirect: '/dashboard'
      },
      {
        path: '/orders',
        redirect: '/orders/list'
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '数据统计' }
      },
      {
        path: '/orders/list',
        name: 'orders',
        component: () => import('@/views/orders/index.vue'),
        meta: { title: '订单列表' }
      },
      {
        path: '/orders/detail/:id',
        name: 'orderDetail',
        component: () => import('@/views/orders/detail.vue'),
        meta: { title: '订单详情' }
      },
      {
        path: '/orders/fee-rules',
        name: 'orderFeeRules',
        component: () => import('@/views/orders/fee-rules/index.vue'),
        meta: { title: '订单收费计算规则' }
      },
      {
        path: '/orders/fee-rules/detail/:id',
        name: 'orderFeeRuleDetail',
        component: () => import('@/views/orders/fee-rules/detail.vue'),
        meta: { title: '规则详情' }
      },
      {
        path: '/orders/commission-roles',
        name: 'commissionRoles',
        component: () => import('@/views/orders/commission-roles/index.vue'),
        meta: { title: '服务费角色管理' }
      },
      {
        path: '/orders/commission-allocation-rules',
        name: 'orderCommissionAllocationRules',
        component: () => import('@/views/orders/commission-allocation-rules/index.vue'),
        meta: { title: '订单服务费分配规则' }
      },
      {
        path: '/user/users',
        name: 'users',
        component: () => import('@/views/users/index.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: '/user/users/detail/:id',
        name: 'userDetail',
        component: () => import('@/views/users/detail.vue'),
        meta: { title: '用户详情' }
      },
      {
        path: '/user/runners',
        name: 'runners',
        component: () => import('@/views/runners/index.vue'),
        meta: { title: '跑腿员管理' }
      },
      {
        path: '/user/runners/detail/:id',
        name: 'runnerDetail',
        component: () => import('@/views/runners/detail.vue'),
        meta: { title: '跑腿员详情' }
      },
      {
        path: '/user/runner-types',
        name: 'runnerTypes',
        component: () => import('@/views/runner-types/index.vue'),
        meta: { title: '跑手类型管理' }
      },
      {
        path: '/user/shops',
        name: 'shops',
        component: () => import('@/views/shops/index.vue'),
        meta: { title: '商家管理' }
      },
      {
        path: '/user/shops/detail/:id',
        name: 'shopDetail',
        component: () => import('@/views/shops/detail.vue'),
        meta: { title: '商家详情' }
      },
      {
        path: '/user/shops/edit/:id',
        name: 'shopEdit',
        component: () => import('@/views/shops/edit.vue'),
        meta: { title: '修改商家资料' }
      },
      {
        path: '/shop-referrers/list',
        name: 'shopReferrers',
        component: () => import('@/views/shop-referrers/index.vue'),
        meta: { title: '店家推广人列表' }
      },
      {
        path: '/shop-referrers/detail/:id',
        name: 'shopReferrerDetail',
        component: () => import('@/views/shop-referrers/detail.vue'),
        meta: { title: '店家推广人详情' }
      },
      {
        path: '/shop-referrers',
        redirect: '/shop-referrers/list'
      },
      {
        path: '/shop-referrer-shop/list',
        name: 'shopReferrerShopList',
        component: () => import('@/views/shop-referrer-shop/index.vue'),
        meta: { title: '推荐人-店家关联' }
      },
      {
        path: '/runner-referrer/referrers',
        name: 'runnerReferrers',
        component: () => import('@/views/runner-referrers/index.vue'),
        meta: { title: '跑手推广人列表' }
      },
      {
        path: '/runner-referrer/detail/:id',
        name: 'runnerReferrerDetail',
        component: () => import('@/views/runner-referrers/detail.vue'),
        meta: { title: '跑手推广人详情' }
      },
      {
        path: '/runner-referrer',
        redirect: '/runner-referrer/referrers'
      },
      {
        path: '/runner-referrer/list',
        name: 'runnerReferrerRunnerList',
        component: () => import('@/views/runner-referrer-runner/index.vue'),
        meta: { title: '推广人-跑手关联' }
      },
      {
        path: '/products/categories',
        name: 'categories',
        component: () => import('@/views/productCategories/index.vue'),
        meta: { title: '物品分类' }
      },
      {
        path: '/products/list',
        name: 'products',
        component: () => import('@/views/products/index.vue'),
        meta: { title: '物品列表' }
      },
      {
        path: '/products/specs',
        name: 'productSpecs',
        component: () => import('@/views/products/specs/index.vue'),
        meta: { title: '商品规格' }
      },
      {
        path: '/products/sku',
        name: 'productSku',
        component: () => import('@/views/products/sku/index.vue'),
        meta: { title: 'SKU 管理' }
      },
      {
        path: '/products/sku/detail/:id',
        name: 'skuDetail',
        component: () => import('@/views/products/sku/detail.vue'),
        meta: { title: 'SKU 详情' }
      },
      {
        path: '/products/detail/:id',
        name: 'productDetail',
        component: () => import('@/views/products/detail.vue'),
        meta: { title: '物品详情' }
      },
      {
        path: '/communities',
        name: 'communities',
        component: () => import('@/views/communities/index.vue'),
        meta: { title: '小区管理' }
      },
      {
        path: '/community-agents',
        redirect: '/community-agents/list'
      },
      {
        path: '/community-agents/list',
        name: 'communityAgents',
        component: () => import('@/views/communityAgents/index.vue'),
        meta: { title: '小区代理列表' }
      },
      {
        path: '/community-agents/communities',
        name: 'communityAgentCommunities',
        component: () => import('@/views/communityAgentCommunities/index.vue'),
        meta: { title: '代理-小区关联' }
      },
      {
        path: '/communities/detail/:id',
        name: 'communityDetail',
        component: () => import('@/views/communities/detail.vue'),
        meta: { title: '小区详情' }
      },
      {
        path: '/communities/:id',
        name: 'communityBuildings',
        component: () => import('@/views/communities/buildings.vue'),
        meta: { title: '楼栋管理' }
      },
      {
        path: '/statistics',
        name: 'statistics',
        component: () => import('@/views/statistics/index.vue'),
        meta: { title: '数据报表' }
      },

      {
        path: '/articles/categories',
        name: 'articleCategories',
        component: () => import('@/views/articles/categories/index.vue'),
        meta: { title: '文章分类' }
      },
      {
        path: '/articles/list',
        name: 'articles',
        component: () => import('@/views/articles/list/index.vue'),
        meta: { title: '文章列表' }
      },
      {
        path: '/media',
        name: 'media',
        component: () => import('@/views/media/index.vue'),
        meta: { title: '素材库' }
      },
      {
        path: '/service_type',
        name: 'serviceType',
        component: () => import('@/views/service-type/index.vue'),
        meta: { title: '服务类型' }
      },
      {
        path: '/system',
        name: 'system',
        component: () => import('@/views/system/index.vue'),
        meta: { title: '系统设置' }
      },
      {
        path: '/platform-config',
        name: 'platformConfig',
        component: () => import('@/views/platform-config/index.vue'),
        meta: { title: '平台配置' }
      },
      {
        path: '/system/operation-logs',
        name: 'operationLogs',
        component: () => import('@/views/operation-logs/index.vue'),
        meta: { title: '操作日志' }
      },
      {
        path: '/admin-accounts/list',
        name: 'adminList',
        component: () => import('@/views/admins/index.vue'),
        meta: { title: '管理员列表' }
      },
      {
        path: '/admin-accounts/create',
        name: 'adminCreate',
        component: () => import('@/views/admins/edit.vue'),
        meta: { title: '新增管理员' }
      },
      {
        path: '/admin-accounts/edit/:id',
        name: 'adminEdit',
        component: () => import('@/views/admins/edit.vue'),
        meta: { title: '编辑管理员' }
      },
      {
        path: '/admin-accounts/roles',
        name: 'roleList',
        component: () => import('@/views/admin-roles/index.vue'),
        meta: { title: '管理员角色' }
      },
      {
        path: '/role',
        name: 'roleMaster',
        component: () => import('@/views/role/index.vue'),
        meta: { title: '角色总表' }
      },
      {
        path: '/finance/transactions',
        name: 'transactions',
        component: () => import('@/views/finance/transactions.vue'),
        meta: { title: '钱包流水' }
      },
      {
        path: '/finance/withdraw',
        name: 'withdrawAudit',
        component: () => import('@/views/finance/withdraws.vue'),
        meta: { title: '提现审核' }
      },
      {
        path: '/shop-wallet/recharges',
        name: 'shopWalletRechargeAudit',
        component: () => import('@/views/shop-wallet-recharge/index.vue'),
        meta: { title: '店家钱包充值审核' }
      }
    ]
  }
]